import { IFormsyDecorator } from "formsy-react";
import * as React from "react";
import Input from "./Input";

interface Props extends IFormsyDecorator {
  placeholder?: string;
  innerRef: React.Ref<any>;
  skipFirstInput: boolean;
  onValidInput?(value: string): void;
  min?: string | number;
  onChange?: (date: string) => void;
}

class DateInput extends React.Component<Props> {
  render() {
    return (
      <Input
        value={this.props.value}
        placeholder={this.props.placeholder}
        required={this.props.required}
        type="date"
        name={this.props.name}
        ref={this.props.innerRef}
        skipFirstInput={this.props.skipFirstInput}
        onValidInput={this.props.onValidInput}
        min={this.props.min}
        max={"2100-01-01"}
        onChange={this.props.onChange}
      />
    );
  }
}

export default React.forwardRef((props: Props, ref) => (
  <DateInput innerRef={ref} {...props} />
));
